import { fexGet } from "@/utils/fex"

export const getDevCenterData = async ({userId}:{userId:string})=>{
    const res = await fexGet(`api/dev-center`)
    return res
}